import { useState, useEffect } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_INVOICE } from "../../../../../ApiServices/BaseURL";

const InvoiceTaxationController = (taxSgst, taxCgst, taxIgst, taxConvFee, errorSettings, onRefresh) => {
  const [cgst, setCgst] = useState(null);
  const [sgst, setSgst] = useState(null);
  const [igst, setIgst] = useState(null);
  const [conveyanceFee, setConveyanceFee] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [cgstError, setCgstError] = useState("");
  const [sgstError, setSgstError] = useState("");
  const [igstError, setIgstError] = useState("");
  const [convFeeError, setConvFeeError] = useState("");

  useEffect(() => {
    setCgst(taxCgst);
    setSgst(taxSgst);
    setIgst(taxIgst);
    setConveyanceFee(taxConvFee);
    setError(errorSettings);
  }, [taxSgst, taxCgst, taxIgst, taxConvFee, errorSettings]);

  const handleInputChange = (field, value) => {
    if (field === "cgst") setCgst(value);
    if (field === "sgst") setSgst(value);
    if (field === "igst") setIgst(value);
    if (field === "conveyanceFee") setConveyanceFee(value);
  };


  const handleUpdateTaxation = async () => {

    try {
      setError('');
      setSuccess('');
      setCgstError("");
      setSgstError("");
      setIgstError("");
      setConvFeeError("");

      if (!cgst) {
        setCgstError("Please enter the cgst");
        return;
      }

      if (!sgst) {
        setSgstError("Please enter the sgst");
        return;
      }

      if (!igst) {
        setIgstError("Please enter the igst");
        return;
      }

      if (!conveyanceFee) {
        setConvFeeError("Please enter the conveyance fee");
        return;
      }

      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "action": "TAXATION_UPDATE",
        "acc_tax_sgst": sgst,
        "acc_tax_cgst": cgst,
        "acc_tax_igst": igst,
        "acc_tax_conv_fee": conveyanceFee,
      }

      //console.log('handleUpdateTaskType Data', payLoad);
      // Make the API call
      const response = await postData(ORG_INVOICE, payLoad);
      const responseData = await response.json();
      //console.log('handleUpdateTaskType response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setSuccess(responseData?.info);
            setTimeout(() => {
              setSuccess('');
              setIsEditing(false);
              onRefresh();
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to Update GST values. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to Update GST values.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
        // An error occurred in setting up the request
        setError(`Failed to Update GST values. Please check your network connection and try again.`);
      
    } finally {
      setLoading(false);
    }


    // onValueChange(clientData); // Send data to Dashboard
    // onClose(); // Close modal
  };

  const handleCancel = ()=>{
    setIsEditing(false);
    console.log('refresh')
    setCgst(taxCgst);
    setSgst(taxSgst);
    setIgst(taxIgst);
    setConveyanceFee(taxConvFee);
  }

  return {
    cgst,
    setCgst,
    sgst,
    setSgst,
    igst,
    setIgst,
    conveyanceFee,
    setConveyanceFee,
    handleUpdateTaxation,
    loading,
    error,
    success,
    isEditing,
    setIsEditing,
    cgstError,
    sgstError,
    igstError,
    convFeeError,handleCancel,
    handleInputChange,
  };
};

export default InvoiceTaxationController;
